module.exports = "<div class=calendar-remind-item-comment> <div class=content> <div class=content-left><span class=\"triangle-right circle\"></span></div> <span class=fileName>{{fileName}}</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.remind.list/calendar.remind.item/calendar.remind.item.html
// module id = 4925
// module chunks = 50